import { useRentReportingController } from "./rent-reporting-controller";
import { FilterOptions } from "../types";

export const useCombinedRentReportingController = (
  options: FilterOptions = {}
) => {
  const rentReporting = useRentReportingController(options);

  const pendingCountMeta = {
    data: rentReporting.subscribersMeta.data?.extra?.counts?.pending,
    isLoading: rentReporting.subscribersMeta.isLoading,
    isFetching: rentReporting.subscribersMeta.isFetching,
    error: rentReporting.subscribersMeta.error
  };

  const needToReportCountMeta = {
    data: rentReporting.subscribersMeta.data?.extra?.counts?.need_to_report,
    isLoading: rentReporting.subscribersMeta.isLoading,
    isFetching: rentReporting.subscribersMeta.isFetching,
    error: rentReporting.subscribersMeta.error
  };

  return {
    ...rentReporting,
    pendingCountMeta,
    needToReportCountMeta
  };
};
